import React from "react";

const BackgroundDecor = ({ currentTheme }) => {
  const backgroundOverlayStyles = currentTheme?.background?.overlay || {};
  const decorativeContainerStyles = currentTheme?.background?.decorative?.container || {};
  const circle1Styles = currentTheme?.background?.decorative?.circle1 || {};
  const circle2Styles = currentTheme?.background?.decorative?.circle2 || {};

  return (
    <>
      <div style={backgroundOverlayStyles} />
      <div style={decorativeContainerStyles}>
        <div style={circle1Styles} />
        <div style={circle2Styles} />
      </div>
    </>
  );
};

export default BackgroundDecor;